import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/location.png'


const _withScopeId = n => (_pushScopeId("data-v-56c71152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aboutus page-joinus" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "adv" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "加入我们"),
  /*#__PURE__*/_createElementVNode("i", { class: "sub" }, "JOIN US")
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "path" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "location",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "当前位置:", -1))
const _hoisted_7 = { class: "company rounded" }

import { onMounted, reactive, ref, markRaw } from "vue";
import type { TabsPaneContext } from 'element-plus';
import CorporateCulture from './components/CorporateCulture.vue';
import JobRequirements from './components/JobRequirements.vue';
import useGetNewsNavList from "@/hooks/useGetNewsNavList";
import { IList } from "@/interface/article";

export default /*#__PURE__*/_defineComponent({
  __name: 'joinUs',
  setup(__props) {

const list = ref<Array<IList>>([])

const tabArr = reactive({
    "企业文化": markRaw(CorporateCulture),
    "岗位需求": markRaw(JobRequirements)
})

const { getNewsInfo } = useGetNewsNavList("/joinus", pullData);
function pullData(res) {
    list.value = res.data.leftList || [];
}
onMounted(() => {
    getNewsInfo();
});
const activeName = ref('企业文化')

const handleClick = (tab: TabsPaneContext, event: Event) => {
    console.log(tab.paneName, event.target)
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("span", null, "首页 > 加入我们 > " + _toDisplayString(activeName.value), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
          type: "card",
          class: "tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                label: item.title,
                name: item.title,
                key: item.id
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(tabArr[item.title]), {
                    logo: item.logo,
                    id: item.id
                  }, null, 8, ["logo", "id"]))
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})